const isReceiptObject = (value) =>
  value &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  typeof value.url === "string" &&
  value.url.length > 0;

const flattenReceipts = (input) => {
  if (input == null || input === "") return [];

  if (typeof input === "string") {
    const trimmed = input.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
      return [{ url: trimmed, type: "image/jpeg" }];
    }

    try {
      return flattenReceipts(JSON.parse(trimmed));
    } catch {
      return [];
    }
  }

  if (Array.isArray(input)) {
    return input.flatMap((item) => flattenReceipts(item));
  }

  if (isReceiptObject(input)) {
    return [input];
  }

  return [];
};

export const parseReceipts = (receipts) => {
  const flattened = flattenReceipts(receipts);
  const seen = new Set();

  return flattened.filter((receipt) => {
    if (!isReceiptObject(receipt)) return false;
    if (seen.has(receipt.url)) return false;
    seen.add(receipt.url);
    return true;
  });
};

export const getPrimaryReceipt = (receipts) => parseReceipts(receipts)[0] || null;

export const isPdfReceipt = (receipt) => {
  if (!receipt) return false;
  if (receipt.type === "application/pdf") return true;
  return typeof receipt.url === "string" && receipt.url.toLowerCase().includes(".pdf");
};
